import { render, staticRenderFns } from "./ContactBlock.vue?vue&type=template&id=f0cf5fd0&scoped=true"
import script from "./ContactBlock.vue?vue&type=script&lang=js"
export * from "./ContactBlock.vue?vue&type=script&lang=js"
import style0 from "./ContactBlock.vue?vue&type=style&index=0&id=f0cf5fd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0cf5fd0",
  null
  
)

export default component.exports